import { render, staticRenderFns } from "./recruitInfo.vue?vue&type=template&id=1a155ee0&scoped=true"
import script from "./recruitInfo.vue?vue&type=script&lang=js"
export * from "./recruitInfo.vue?vue&type=script&lang=js"
import style0 from "./recruitInfo.vue?vue&type=style&index=0&id=1a155ee0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a155ee0",
  null
  
)

export default component.exports